import {IconConfig} from "./icon.model";

export const iconsMenu: IconConfig[] = [
  {
    name: 'games-menu',
    path: 'assets/img/mat-icons/menu/game-menu.svg',
  },
];
